/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Statsbar_Offerstracked2Inputs */

const id_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Dilacak`)
};

const ms_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Dikesan`)
};

const da_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud spores`)
};

const de_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgte Angebote`)
};

const en_us2_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers Tracked`)
};

const es_es2_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos rastreados`)
};

const es_mx2_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas rastreadas`)
};

const fil_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer na Natrack`)
};

const fr_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres suivies`)
};

const it_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte tracciate`)
};

const hu_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok követve`)
};

const nl_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen gevolgd`)
};

const no_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud spores`)
};

const pl_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzone oferty`)
};

const pt_br2_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos rastreados`)
};

const pt_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas registadas`)
};

const ro_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte urmărite`)
};

const fi_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuratut tarjoukset`)
};

const sv_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spårade erbjudanden`)
};

const vi_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi được theo dõi`)
};

const tr_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzlenen Teklifler`)
};

const cs_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledovaných nabídek`)
};

const bg_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проследени оферти`)
};

const ru_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживаемых предложений`)
};

const uk_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відстежуваних пропозицій`)
};

const ar_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض المتعقبة`)
};

const hi_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक किए गए ऑफ़र`)
};

const th_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอที่ติดตาม`)
};

const ja_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追跡中のオファー`)
};

const zh_cn2_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追踪目录项`)
};

const zh_hant1_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追蹤目錄項目`)
};

const ko_home_statsbar_offerstracked2 = /** @type {(inputs: Home_Statsbar_Offerstracked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추적 중인 오퍼`)
};

/**
* | output |
* | --- |
* | "Offers Tracked" |
*
* @param {Home_Statsbar_Offerstracked2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_statsbar_offerstracked2 = /** @type {((inputs?: Home_Statsbar_Offerstracked2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Statsbar_Offerstracked2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_statsbar_offerstracked2(inputs)
	if (locale === "ms") return ms_home_statsbar_offerstracked2(inputs)
	if (locale === "da") return da_home_statsbar_offerstracked2(inputs)
	if (locale === "de") return de_home_statsbar_offerstracked2(inputs)
	if (locale === "en-US") return en_us2_home_statsbar_offerstracked2(inputs)
	if (locale === "es-ES") return es_es2_home_statsbar_offerstracked2(inputs)
	if (locale === "es-MX") return es_mx2_home_statsbar_offerstracked2(inputs)
	if (locale === "fil") return fil_home_statsbar_offerstracked2(inputs)
	if (locale === "fr") return fr_home_statsbar_offerstracked2(inputs)
	if (locale === "it") return it_home_statsbar_offerstracked2(inputs)
	if (locale === "hu") return hu_home_statsbar_offerstracked2(inputs)
	if (locale === "nl") return nl_home_statsbar_offerstracked2(inputs)
	if (locale === "no") return no_home_statsbar_offerstracked2(inputs)
	if (locale === "pl") return pl_home_statsbar_offerstracked2(inputs)
	if (locale === "pt-BR") return pt_br2_home_statsbar_offerstracked2(inputs)
	if (locale === "pt") return pt_home_statsbar_offerstracked2(inputs)
	if (locale === "ro") return ro_home_statsbar_offerstracked2(inputs)
	if (locale === "fi") return fi_home_statsbar_offerstracked2(inputs)
	if (locale === "sv") return sv_home_statsbar_offerstracked2(inputs)
	if (locale === "vi") return vi_home_statsbar_offerstracked2(inputs)
	if (locale === "tr") return tr_home_statsbar_offerstracked2(inputs)
	if (locale === "cs") return cs_home_statsbar_offerstracked2(inputs)
	if (locale === "bg") return bg_home_statsbar_offerstracked2(inputs)
	if (locale === "ru") return ru_home_statsbar_offerstracked2(inputs)
	if (locale === "uk") return uk_home_statsbar_offerstracked2(inputs)
	if (locale === "ar") return ar_home_statsbar_offerstracked2(inputs)
	if (locale === "hi") return hi_home_statsbar_offerstracked2(inputs)
	if (locale === "th") return th_home_statsbar_offerstracked2(inputs)
	if (locale === "ja") return ja_home_statsbar_offerstracked2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_statsbar_offerstracked2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_statsbar_offerstracked2(inputs)
	return ko_home_statsbar_offerstracked2(inputs)
});
export { home_statsbar_offerstracked2 as "home.statsBar.offersTracked" }